const domParser = new DOMParser();
function getLoaderHtml(className = 'c-loader c-loader--button c-loader--fullscreen') {
    const html = `<div class="${className} m-auto">
  <div class="c-loader__spinner"></div>
  </div>`;
    return domParser.parseFromString(html, 'text/html').body.childNodes[0];
}
function showLoader(target, options) {
    const loader = getLoaderHtml(options.className);
    const content = target.innerHTML;
    if (options.hideContent) {
        target.innerHTML = `<span class="invisible">${target.innerHTML}</span>`;
    }
    else {
        target.innerHTML = '';
    }
    target.appendChild(loader);
    return () => {
        try {
            if (options.hideContent) {
                target.innerHTML = content;
            }
            else {
                target.removeChild(loader);
            }
            // eslint-disable-next-line no-empty
        }
        catch { }
    };
}
export default showLoader;
